/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FundGroupDto
 */
export interface FundGroupDto {
  /**
   *
   * @type {string}
   * @memberof FundGroupDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof FundGroupDto
   */
  name: string;
}

export function FundGroupDtoFromJSON(json: any): FundGroupDto {
  return FundGroupDtoFromJSONTyped(json, false);
}

export function FundGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FundGroupDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function FundGroupDtoToJSON(value?: FundGroupDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
